// Women's Circles Frome - Service Page
import ServicePageTemplate from "../../components/templates/ServicePageTemplate";

const WomensCirclesFrome = () => {
  return (
    <ServicePageTemplate
      // SEO
      pageTitle="Women's Circles in Frome, Somerset | Sacred Gatherings"
      metaDescription="Women's healing circles in Frome, Somerset. Sacred gatherings featuring meditation, sound healing, cacao ceremony, and sisterhood."
      canonical="https://annelielily.com/womens-circles/frome"
      
      // Hero
      heroLabel="Women's Circles in Frome"
      heroTitle="Women's Circles"
      heroDescription="Safe, nurturing spaces for women to pause, reconnect, and be supported. These gentle, heart-led gatherings offer time away from everyday life to rest, reflect, and experience the power of sisterhood."
      heroImage="https://images.pexels.com/photos/6787202/pexels-photo-6787202.jpeg?auto=compress&cs=tinysrgb&w=800"
      
      // Content
      introTitle="The Power of Circle"
      introText={[
        "Throughout history, women have gathered in circles to share, support, and heal together. In our busy modern lives, these sacred spaces of connection are more valuable than ever.",
        "Annelie's Women's Circles in Frome offer a sanctuary from the demands of daily life. Here, you can put down the 'to-do' lists, step away from the constant doing, and simply be - held by a community of women who understand.",
        "Each circle is unique, woven together with meditation, gentle yoga or movement, sound healing, cacao ceremony, breathwork, and the simple magic of being witnessed and heard. You don't need to share if you don't want to - your presence is enough."
      ]}
      
      // Benefits
      benefits={[
        {
          title: "Deep Connection",
          description: "Experience the profound support that comes from gathering with other women in a safe, sacred space."
        },
        {
          title: "Time to Rest",
          description: "Step away from doing and simply be. Allow yourself to receive nourishment and care."
        },
        {
          title: "Emotional Release",
          description: "In the supportive container of circle, emotions can flow and be witnessed without judgement."
        },
        {
          title: "Spiritual Nourishment",
          description: "Connect with practices that feed your soul - meditation, sound healing, ceremony, and more."
        },
        {
          title: "Community",
          description: "Build meaningful connections with like-minded women in your local area."
        },
        {
          title: "Self-Discovery",
          description: "The reflective practices of circle often bring insights and clarity about your own path."
        }
      ]}
      
      // Who is it for
      idealFor={[
        "Any woman seeking connection and community",
        "Those feeling overwhelmed or disconnected from themselves",
        "Women going through life transitions or challenges",
        "Anyone curious about ritual, ceremony, and sacred practices",
        "Those wanting to explore meditation and sound healing in a group",
        "Women looking for a regular practice of self-care and reflection",
        "No experience needed - just an open heart"
      ]}
      
      // What to expect
      whatToExpect={[
        "Women's Circles typically last 1.5-2 hours and are held monthly in Frome. Sometimes there's optional yoga beforehand for those who want to ease into the evening.",
        "You'll be welcomed into a beautiful space prepared with candles, cushions, and soft lighting. The circle opens with a grounding practice to help you arrive fully and leave the outside world behind.",
        "What happens in circle varies each month but may include: guided meditation and visualisation, gentle movement or restorative yoga, sound baths, breathwork, cacao ceremony, working with crystals and guidance cards, and sharing circles.",
        "You're never required to speak or share - it's perfectly fine to simply be present and witness. What's shared in circle stays in circle, creating a safe container for vulnerability.",
        "Bring water, a blanket or shawl, and a journal if you like. Wear comfortable clothing. Everything else is provided."
      ]}
      
      // FAQ
      faqs={[
        {
          question: "Do I need to be spiritual to attend?",
          answer: "Not at all. Women's Circles are for anyone seeking connection, rest, and a supportive community. Whatever your beliefs, you're welcome here. Take what resonates and leave what doesn't."
        },
        {
          question: "Will I have to share personal things?",
          answer: "Sharing is always optional. Some women find it healing to share; others prefer to listen and witness. Both are equally valuable. You'll never be put on the spot or pressured to speak."
        },
        {
          question: "What is a cacao ceremony?",
          answer: "Cacao ceremony involves drinking ceremonial-grade chocolate (not like regular hot chocolate!) in a ritual setting. Cacao is a gentle heart-opener that has been used in sacred practices for thousands of years. It's completely optional."
        },
        {
          question: "Can I bring a friend?",
          answer: "Absolutely! Many women find it easier to attend their first circle with a friend. All women are welcome, and the more diverse our circle, the richer the experience."
        }
      ]}
      
      // Testimonials
      testimonials={[
        {
          quote: "The cacao ceremony was such a beautiful experience. Annelie creates a sacred and safe space that allows you to really connect with yourself and others. I left feeling nourished on every level.",
          name: "Cacao Ceremony Participant"
        },
        {
          quote: "Words simply cannot express the feeling of rejuvenation and peace I have following every yoga session. I feel restored in every cell of my body. Annelie is a breath of fresh air, grounding me with her gentle approach and sense of humour. A truly wonderful human being.",
          name: "Alex",
          location: "Exeter"
        }
      ]}
      
      // Related
      currentSlug="womens-circles/frome"
      
      // Schema
      serviceType="WellnessService"
      serviceName="Women's Circles in Frome"
      serviceDescription="Monthly women's healing circles in Frome, Somerset. Sacred gatherings featuring meditation, sound healing, cacao ceremony and sisterhood."
    />
  );
};

export default WomensCirclesFrome;
